import * as React from 'react';
import { UseSelectionInterface } from './Filter.interface';

const useTextInput = (initialChecked: string[]): UseSelectionInterface => {
  const [checkedEntity, setCheckedEntity] = React.useState<string[]>(['']);

  const onChangeHandler = (key: string) => {
    setCheckedEntity([key]);
  };

  React.useEffect(() => {
    setCheckedEntity(initialChecked);
  }, [initialChecked]);

  return {
    checkedEntity,
    onChangeHandler,
  };
};

export default useTextInput;
